<ng-container *ngIf="documents$ | async as documents">
  <mat-table
    class="documents-table"
    #table
    [dataSource]="dataSource"
    matSort
    matSortActive="date"
    matSortDirection="desc"
    matSortDisableClear
    fusePerfectScrollbar
    *ngIf="!documents.error">
    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell i18n *cdkHeaderCellDef>Название</mat-header-cell>
      <mat-cell *cdkCellDef="let item">
        {{ item.name }}
      </mat-cell>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
      <mat-header-cell i18n *matHeaderCellDef>Тип</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <p class="text-truncate">{{ item.extension }}</p>
      </mat-cell>
    </ng-container>

    <!-- Size Column -->
    <ng-container cdkColumnDef="size">
      <mat-header-cell i18n *cdkHeaderCellDef>Размер</mat-header-cell>
      <mat-cell *cdkCellDef="let item" class="hidden sm:flex">
        <p class="text-truncate">
          {{ item.size | fileSize }}
        </p>
      </mat-cell>
    </ng-container>

    <!-- Date Column -->
    <ng-container cdkColumnDef="date">
      <mat-header-cell i18n *cdkHeaderCellDef>Дата</mat-header-cell>
      <mat-cell *cdkCellDef="let item">
        <p class="text-truncate">
          {{ item.date | date : 'dd.MM.yyyy' }}
        </p>
      </mat-cell>
    </ng-container>

    <!-- Download Column -->
    <ng-container matColumnDef="download">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell class="flex flex-col justify-center items-center" *matCellDef="let item">
        <button mat-icon-button (click)="downloadOrderDocument(item)" *ngIf="!downloading.has(item.id)">
          <mat-icon class="mat-24" aria-label="">download</mat-icon>
        </button>

        <mat-spinner [diameter]="20" *ngIf="downloading.has(item.id)"></mat-spinner>
      </mat-cell>
    </ng-container>

    <!-- Print Column -->
    <ng-container matColumnDef="print">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell class="flex flex-col justify-center items-center" *matCellDef="let item"> </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>

    <mat-row *cdkRowDef="let item; columns: displayedColumns" class="file"></mat-row>
  </mat-table>

  <div *ngIf="!documents.error && !documents.result" class="p-6">Loading…</div>

  <div *ngIf="documents.error" class="p-6">
    {{ documents.error | json }}
  </div>
</ng-container>
